import { Entity } from './entity';

export class LegalEntityTransaction {
  entity: Entity;
  isSource: boolean;
  details: string;
}
